import React, { useEffect, useState } from "react";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";;

function MyEditor() {
  const [description, setDescription] = useState("");
  const [aboutProjectState, setAboutProjectState] = useState(EditorState.createEmpty());

  const handleHandoverAboutChangeInput = (event) => {
    setAboutProjectState(event);
    setDescription("" + draftToHtml(convertToRaw(event.getCurrentContent())));
  };

  return (
    <React.Fragment>
      <Editor
        name="project_about"
        id="exampleFormControlDescription"
        editorState={aboutProjectState}
        stripPastedStyles={true}
        wrapperClassName="demo-wrapper"
        className="mt-2"
        editorClassName="demo-editor"
        onEditorStateChange={handleHandoverAboutChangeInput}
        toolbar={{
          options: ["inline", "remove", "history"],
          inline: {
            inDropdown: false,
            options: ["bold", "italic", "underline", "strikethrough"],
          },
        }}
      />
    </React.Fragment>
  );
}

export default MyEditor;
